export function getUrl(url: string, params: { [key: string]: string }): string {
  return url.replace(/{(\w+)}/g, (_, key) => {
    if (params[key] !== undefined) {
      return params[key]
    }
    throw new Error(`Missing value for URL parameter: ${key}`)
  })
}

export function extractDomainPath(url: string): string {
  return url.replace(/^https?:\/\//, '')
}
